import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import { urlEspecial, queryStrStart, queryStrSndParam, queryStrCategory, queryStrWinner,} from '../../Constants';

const BestPlayer = props => {

    const { colorPlayer, slugCategory, urlAssets, winnerInfo } = props;
    const { title, slug, player, team } = winnerInfo;

    return (
        <section className={`position-relative col-md-auto px-0 text-center`}>
            <article className="position-relative content overflow-hidden">
                <a href={`${urlEspecial}${queryStrStart}${queryStrCategory}=${slugCategory}${queryStrSndParam}${queryStrWinner}=${slug}`}>
                    <LazyLoadImage
                        alt={player}
                        className="img-fluid"
                        effect="blur"
                        src={`${urlAssets}/img/portada/${slugCategory}/${slug}.png`}
                    />
                    <div className="px-2 content-overlay"></div>
                    <article className="position-absolute top-50 start-50 w-100 px-4 text-start content-details fadein-bottom">
                        <p className="mb-2 text-white winner-achievment">{title}</p>
                        <h4 className="d-table border-top border-white mb-2 pt-2 winner-name" style={{ color: colorPlayer }}>{player}</h4>
                        <p className="mb-0 text-white winner-team">{team}</p>
                    </article>
                </a>                
            </article>            
        </section>
    )
}

export default BestPlayer;

BestPlayer.propTypes = {
    colorPlayer: PropTypes.string.isRequired,
    slugCategory: PropTypes.string.isRequired,    
    urlAssets: PropTypes.string.isRequired,
    winnerInfo: PropTypes.object.isRequired
}
